import { render, staticRenderFns } from "./CampaignReports.vue?vue&type=template&id=65c1a270&"
import script from "./CampaignReports.vue?vue&type=script&lang=ts&"
export * from "./CampaignReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports